export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitilizeAll = (str: string, ignore?: string[]) => {
  const wordsToIgnore = ignore?.map((i) => i.toLowerCase());
  const words = str.toLowerCase().split(" ");

  if (wordsToIgnore) {
    return words
      .map((word) => (wordsToIgnore.includes(word) ? word : capitalize(word)))
      .join(" ");
  }

  return words.map((word) => capitalize(word)).join(" ");
};
